import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ISpeakingRubricItemScaleBody } from '../../../models/newSpeaking.model';
import SortButton from './SortButton';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { getDetailCode } from '../../../lib/util';
import { Select } from 'antd';
import styled from 'styled-components';

const Table = styled.table`
  .close-button {
    position: relative;
    top: -110px;
    left: 65px;
    font-size: 14px;
    color: firebrick;
    cursor: pointer;
  }
`;

interface IProps {
  data: ISpeakingRubricItemScaleBody[];
  disabled: boolean;
  raiseScale(currentOrderSeq: number): void;
  lowerScale(currentOrderSeq: number): void;
  deleteScale(orderSeq: number): void;
  onChangeScale(
    value: string,
    index: number,
    key: keyof ISpeakingRubricItemScaleBody,
  ): void;
  eduStepCode: string;
}

const ItemSaveTable: FC<IProps> = ({
  data,
  disabled,
  raiseScale,
  lowerScale,
  deleteScale,
  onChangeScale,
  eduStepCode,
}) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const TE0011 = getDetailCode(commonCodes, 'TE0011');

  return (
    <div className="comm-table__area rowType mt-0">
      <Table>
        <colgroup>
          <col width="150px" />
          <col width="150px" />
          <col width="*" />
        </colgroup>
        <tbody>
          {data.map(
            ({ orderSeq, descriptionEng, descriptionKor, score, tipDescriptionKor, scaleCode }, index) => (
              <Fragment key={`item-save-${index}`}>
                <tr>
                  <td
                    rowSpan={eduStepCode === 'EM' ? 3 : 5}
                    className="align-middle text-center"
                  >
                    {orderSeq}
                    <div className="order-sett__area">
                      <SortButton
                        isDisabled={orderSeq === 1 || disabled}
                        onClick={() => raiseScale(orderSeq)}
                        type="up"
                      />
                      <SortButton
                        isDisabled={orderSeq === data.length || disabled}
                        onClick={() => lowerScale(orderSeq)}
                        type="down"
                      />
                    </div>
                    {eduStepCode === 'MD' && (
                      <span
                        className="close-button"
                        onClick={() => deleteScale(orderSeq)}
                      >
                        X
                      </span>
                    )}
                  </td>
                  <td className="align-middle text-center">
                    {t('cbt.speakRubric.column7')}
                  </td>
                  <td>
                    <input
                      disabled={disabled}
                      type="text"
                      className="form-control"
                      value={descriptionEng}
                      onChange={(e) =>
                        onChangeScale(e.target.value, index, 'descriptionEng')
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle text-center">
                    {t('cbt.speakRubric.column8')}
                  </td>
                  <td>
                    <input
                      disabled={disabled}
                      type="text"
                      className="form-control"
                      value={descriptionKor}
                      onChange={(e) =>
                        onChangeScale(e.target.value, index, 'descriptionKor')
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle text-center">
                    {t('cbt.speakRubric.column9')}
                  </td>
                  <td>
                    <input
                      disabled={disabled}
                      type="text"
                      className="form-control"
                      value={score}
                      onChange={(e) => onChangeScale(e.target.value, index, 'score')}
                    />
                  </td>
                </tr>
                {eduStepCode === 'MD' && (
                  <>
                    <tr>
                      <td className="align-middle text-center">
                        Tip
                      </td>
                      <td>
                        <input
                          disabled={disabled}
                          type="text"
                          className="form-control"
                          value={tipDescriptionKor}
                          onChange={(e) => onChangeScale(e.target.value, index, 'tipDescriptionKor')}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="align-middle text-center">
                        Scale
                      </td>
                      <td>
                        <Select
                          disabled={disabled}
                          value={scaleCode}
                          onChange={value => onChangeScale(value, index, 'scaleCode')}
                          className="w-100"
                        >
                          {TE0011.map(({ korName, detailCode }, index) => (
                            <Select.Option
                              key={`TE0007-${index}`}
                              value={detailCode}
                            >
                              {korName}
                            </Select.Option>
                          ))}
                        </Select>
                      </td>
                    </tr>
                  </>
                )}
              </Fragment>
            ),
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ItemSaveTable;
